<template>
  <b-row class="py-3">
    <b-col lg="6" xl="6" xxl="6" md="5" sm="5">
      <div class="assetcard">
        <Card class="summarycard">
          <template #content>
            <b-row>
              <b-col>
                <h6 class="mx-3 my-2">Asset Information</h6>
                <b-row class="px-3">
                  <b-col sm="12" md="6" lg="6" xl="6">
                    <b-row>
                      <b-col
                        lg="5"
                        md="5"
                        sm="5"
                        cols="5"
                        class="form-field-column"
                      >
                        <p class="light-txt">Code:</p>
                      </b-col>
                      <b-col
                        lg="7"
                        md="7"
                        sm="7"
                        cols="7"
                        class="form-field-column text-start"
                      >
                        <p class="fn14">{{ selectedItem!.Code }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" md="6" lg="6" xl="6">
                    <b-row>
                      <b-col
                        lg="5"
                        md="5"
                        sm="5"
                        cols="5"
                        class="form-field-column"
                      >
                        <p class="light-txt">Barcode:</p>
                      </b-col>
                      <b-col
                        lg="7"
                        md="7"
                        sm="7"
                        cols="7"
                        class="form-field-column text-start"
                      >
                        <p class="fn14">{{ selectedItem!.Barcode }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="px-3">
                  <b-col sm="12" md="6" lg="6" xl="6">
                    <b-row>
                      <b-col
                        lg="5"
                        md="5"
                        sm="5"
                        cols="5"
                        class="form-field-column"
                      >
                        <p class="light-txt">SerialNumber:</p>
                      </b-col>
                      <b-col
                        lg="7"
                        md="7"
                        sm="7"
                        cols="7"
                        class="form-field-column text-start"
                      >
                        <p class="fn14">{{ selectedItem!.SerialNumber }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" md="6" lg="6" xl="6">
                    <b-row>
                      <b-col
                        lg="5"
                        md="5"
                        sm="5"
                        cols="5"
                        class="form-field-column"
                      >
                        <p class="light-txt">ModelNo:</p>
                      </b-col>
                      <b-col
                        lg="7"
                        md="7"
                        sm="7"
                        cols="7"
                        class="form-field-column text-start"
                      >
                        <p class="fn14">{{ selectedItem!.ModelNo }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <!-- <b-col>
                      <h6>DELIVERY TERMS</h6>
                      <p>{{ details.DeliveryTerms }}</p>
                    </b-col> -->
            </b-row>
          </template>
        </Card>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col lg="4" md="4" sm="12" cols="12">
      <div class="field position-relative">
        <label>{{ t("assetManagement.MassConverstion.barcode") }}</label>
        <!-- <AutoComplete v-model="isForm.Name" :name="$t('assetManagement.MassConverstion.assetCode')"
                    :id="$t('assetManagement.MassConverstion.assetCode')" :items="options.assetArray" /> -->
        <!-- {{ model }}k
                {{ selectedItem }} -->
        <!-- {{ selectedItem!.AssetId }} -->
        <!-- {{ selectedItem }} -->
        <!-- {{ selectedItem!.Id }} -->
        <AutoCompleteCustom
          @input="
            commonStore.LoadAsset(
              queryform.Id,
              selectedItem!.Id,
              isForm.Name,
              HospitalId,
              queryform.BranchId,
              queryform.StoreId
            )
          "
          @item-select="assetOnChange"
          :items="commonStore.option.listAsset"
          v-model="isForm.Name"
          :name="t('assetManagement.MassConverstion.barcode')"
          :id="t('assetManagement.MassConverstion.barcode')"
        />

        <i
          class="pi pi-plus plus-position"
          style="color: #3096ff"
          @click="subAssetAddList()"
        ></i>
      </div>
    </b-col>
  </b-row>
  <!-- {{ commonStore.option.listAsset }} -->
  <!-- {{ LoadAsset }} -->

  <b-row>
    <b-col lg="4" md="4" sm="12" cols="12" v-for="item in options.subAssetList">
      <div class="collaboratorscard my-2">
        <div>
          <p class="colloboratorname">{{ item.BarCode }}</p>
          <p class="light-txt fn10">{{ item.AssetName }}</p>
          <p class="light-txt fn10">{{ item.SerialNumber }}</p>
          <p class="light-txt fn10">{{ item.ModelNo }}</p>
        </div>
        <DeleteIcon @click="assetRemoveTagging(item)" />
      </div>
    </b-col>
  </b-row>
  <b-row>
    <div class="d-flex flex-row-reverse my-3">
      <Footer @cancel="$emit('close')" @save="IsSubmit" :cancelhide="true" />
    </div>
  </b-row>
  <CreateSuccessully :visible="showDialog" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import { useRoute } from "vue-router";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../../../modules/Inventory/Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import AutoCompleteCustom from "../../../../../../components/FormComponents/AutoComplete.vue";
import { useCommonStore } from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/store/CommonStore";
import SubAssetRelationshipService from "../../../../../../modules/Inventory/Service/AssetManagement/SubAssetRelationshipService";

import { SubAssetModel } from "../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/subAssetModel";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";

import moment from "moment";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextField,
    CustomDropdown,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    AutoCompleteCustom,
  },
  setup(props, { emit }) {
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let isSubmitCalled = false;
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    const commonStore = useCommonStore();
    const visible = ref(false);

    let HospitalId = Number(session.OrganizationId);
    // let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref({
    //     EntityId: 0
    // });
    // Entitydata.value.EntityId = props.EntityId
    const route = useRoute();

    const data = route.query.data as string;
    const queryform = JSON.parse(data);

    let options: any = ref({
      statusArray: [
        { name: "Active", value: 0 },
        { name: "InActive", value: 1 },
      ],
      assetArray: [
        { name: "Active", value: 0 },
        { name: "InActive", value: 1 },
      ],
      subAssetArray: [
        { name: "Active", value: 0 },
        { name: "InActive", value: 1 },
      ],
      subAssetList: [],
      removeSubAssetList: [],
    });
    let commonVariable = ref({
      HospitalId: session.OrganizationId,
      BranchId: session.BranchId,
      UserId: session.UserId,
      EntityId: props.EntityId,
    });

    let loading = ref(false);

    const isForm = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      Code: "",
      Name: "",
      EntityId: 0,
      EntityOperationId: 0,
    });
    if (model.value != null) {
      IsEdit();
    }

    //Clear Input Fields
    const copyisForm = JSON.parse(JSON.stringify(isForm.value));
    function IsClear() {
      Object.assign(isForm.value, copyisForm);
      isForm.value.Id = 0;
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }

    // Add New PopUp
    function IsCreate() {
      debugger;
      showDialog.value = true;
      GetCode();
    }

    //Row Edit
    async function IsEdit() {
      debugger;
      emit("loadershow");
      try {
        label.value = "Update";
        const EditId = model.value.Id;

        const response = await SubAssetRelationshipService.getfindonedata(
          EditId
        );
        const data = response["result"];
        // alert(JSON.stringify(data))

        options.value.subAssetList = data;

        emit("loaderhide");
        // showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        // alert(error);
      }
    }

    function assetRemoveTagging(index) {
      const mention = options.value.subAssetList.findIndex(
        (item) => item === index
      );
      options.value.subAssetList.splice(mention, 1);
      if (index["Id"] != 0) {
        const newObj = {
          id: index["Id"],
        };
        options.value.removeSubAssetList.push(newObj);
      }
    }

    //Save
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      emit("loadershow");

      try {
        let msg = "";
        isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // isForm.value.BranchId = commonVariable.value.BranchId;
        isForm.value.HospitalId = commonVariable.value.HospitalId;
        isForm.value.ModifiedBy = commonVariable.value.UserId;
        isForm.value.CreatedBy = commonVariable.value.UserId;
        isForm.value.EntityId = Number(commonVariable.value.EntityId);
        if (options.value.subAssetList.length != 0) {
          options.value.subAssetList.map((item) => {
            // item.SupplierId = UpdateId.Id;

            item.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            item.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            item.CreatedBy = commonVariable.value.UserId;
            item.ModifiedBy = commonVariable.value.UserId;
            item.EntityId = Number(commonVariable.value.EntityId);
            item.EntityOperationId = 0;
            item.HospitalId = commonVariable.value.HospitalId;
            item.BranchId = 0;
            item.ParentAssetID = model.value!.Id;
            item.SubAssetID = item.AssetId;
            item.RelationshipType = "";
            item.StartDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            item.EndDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            item.UpdatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            item.UpdatedBy = String(commonVariable.value.UserId);
            item.SupplierName = String(item.supplierName);
          });
          let assetData = options.value.subAssetList.map(
            ({ AgreementDetails, ...rest }) => rest
          );
          const response = await SubAssetRelationshipService.createdata(
            assetData
          );
          if (response["result"].length != 0) {
            showDialog.value = true;
          }
        }
      } catch (error) {
        emit("loaderhide");
        // alert(error);
      }
    });

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        EntityId: commonVariable.value.EntityId,
        HospitalId: commonVariable.value.HospitalId,
        BranchId: commonVariable.value.BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      isForm.value.Code = result;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      emit("close");

      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      isForm.value.Name = "";
    }

    onMounted(() => {
      debugger;
    });
    let assetObj: any = ref();
    // let subAssetList: any = ref([])

    const assetOnChange = async (assetdata) => {
      debugger;
      if (assetdata) {
        isForm.value.Name = assetdata.value.BarCode;
        assetObj.value = assetdata.value;
      }
    };

    const subAssetAddList = () => {
      options.value.subAssetList.push(assetObj.value);
      isForm.value.Name = "";
    };
    const assetDelete = (data) => {
      // deleteCollaboratorsIdarray.value = []
      // addCollaboratorsarray.value = addCollaboratorsarray.value.filter((item) => item.ID != data.ID)
      // addCollaboratorsIdarray.value = addCollaboratorsIdarray.value.filter((item) => item != data.ID)
    };
    return {
      visible,
      assetRemoveTagging,
      assetDelete,
      subAssetAddList,
      HospitalId,
      assetOnChange,
      commonStore,
      options,
      t,
      model,
      showModal: ref(false),
      isForm,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,
      GetCode,
      successpop,
      updatepop,
      alreadyexistpop,
      closetrigger,
      alreadyclosetrigger,
      label,
      loading,
      queryform,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "../../../../../../assets/variables.scss";
@import "../../../../../../assets/main.scss";

.colloboratorname {
  @include custom-text($txtcolor, 12px, 500);
}

.carepathwaybg {
  @extend .overall-bg;
  padding: 15px;
}

.carepathwayformbg {
  @extend .form-white-bg;
  padding: 15px;
}

.collaboratorscard {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  background-color: #fff;
}
</style>
